import { css } from "styled-components";
import { AccordionHeader } from "../../../../components/Accordion";
import { riotProductSkin } from "../riot-product";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  ${AccordionHeader} {
    color: ${paletteTokens.accents1};
  }
`;
//# sourceMappingURL=index.js.map